import {
  Button,
  Grid,
  ListItem,
  ListItemText,
  TextField,
} from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import SaveIcon from "@material-ui/icons/Save";
import React, { useState } from "react";
import { useDispatch } from "react-redux";

import { CustomerGroupListItem } from "../../../../lib/models/CustomerGroupListItem";
import { Dispatch } from "../../../../store";

interface Props {
  customerGroup: CustomerGroupListItem;
  onSave?: () => void;
}

export default function AddCustomerGroupExport({
  customerGroup,
  onSave,
}: Props) {
  const classes = useStyles();
  const dispatch = useDispatch<Dispatch>();

  const [newExportComment, setNewExportComment] = useState<string | null>(null);

  const onExportCommentChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value === "") {
      setNewExportComment(null);
      return;
    }
    setNewExportComment(e.target.value);
  };

  const handleSaveCustomerGroupExport = () => {
    if (typeof onSave === "function") onSave();
    dispatch.customerGroupList.saveCustomerGroupExport({
      customerGroupUuid: customerGroup.uuid,
      comment: newExportComment,
    });
    setNewExportComment(null);
  };

  return (
    <ListItem className={classes.exportListItem}>
      <ListItemText
        primary="Kundennummern der aktuellen Filterergebnisse speichern"
        secondary={
          <Grid
            container
            spacing={2}
            justify="space-between"
            alignItems="center"
          >
            <Grid item>
              <TextField
                fullWidth
                margin="dense"
                placeholder="Bezeichnung (optional)"
                name="comment"
                size="small"
                className={classes.textfield}
                onChange={onExportCommentChange}
                value={newExportComment ?? ""}
              />
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<SaveIcon />}
                onClick={handleSaveCustomerGroupExport}
              >
                Speichern
              </Button>
            </Grid>
          </Grid>
        }
        className={classes.exportListItemText}
      />
    </ListItem>
  );
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    textfield: {
      minWidth: 220,
    },
    exportListItem: {
      justifyContent: "space-between",
      cursor: "auto",
      userSelect: "auto",
    },
    exportListItemText: {
      minWidth: 280,
      marginRight: 16,
    },
  })
);



// WEBPACK FOOTER //
// ./src/components/CustomerGroups/CustomerGroup/CustomerGroupExport/AddCustomerGroupExport.tsx